import cookie from 'js-cookie';


export const loadState = (key) => {
    try {
      var serialState;
      if (key === "token") {
        serialState = cookie.get(key);
      } else {
        serialState = sessionStorage.getItem(key);
      }
      if (serialState === null) {
        return undefined;
      }
      return JSON.parse(serialState);
    } catch (err) {
      return undefined;
    }
};


export const saveState = (key, state) => {
    try {
      const serialState = JSON.stringify(state);
      if (key === "token") {
        cookie.set(key, serialState, { secure: true});
      }
      else {
        sessionStorage.setItem(key, serialState);
      }
    } catch(err) {
        console.log(err);
    }
};